import Dialog from "components/ui/Dialog/Dialog";
import Loader from "components/ui/Loader/Loader";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useState } from "react";
import { useDialog } from "context/DialogContext";
import Textarea from "components/form/Textarea/Textarea";
import { useGroupAccess } from "features/groups/hooks/useGroupAccess";
import PropTypes from "prop-types";
import Alert from "components/ui/Alert/Alert";

const GroupMemberRemoveDialog = ({ groupMemberId, name, onCompleted }) => {
  const [ motivation, setMotivation ] = useState('');
  const [ error, setError ] = useState();
  const { hideDialog } = useDialog();
  const { working, removeAccess } = useGroupAccess();

  const onConfirm = async () => {
    setError(null);

    if (!motivation) {
      setError('U dient een motivatie op te geven om het lid te kunnen verwijderen.');
      return;
    }

    const response = await removeAccess(groupMemberId, motivation);
    const result = response && await response.json();

    if (response?.status !== 200) {
      setError(result?.message || 'U kunt het groepslid op dit moment niet verwijderen. Probeer het later opnieuw.');
      return;
    }

    if (!response?.ok) {
      setError('Er ging iets mis bij het verwijderen, probeer het later opnieuw.');
      return;
    }

    onCompleted(result);
    hideDialog();
  }

  let content =
    <>
      { error && <Alert message={ error } /> }
      <div className={ `dialog__row` }>
        <h3><Trans text={ `Weet u zeker dat u ${ name } uit de groep wilt verwijderen?` }/></h3>
      </div>

      <div className={ `dialog__row` }>
        <h3><Trans text={ `Geef de reden dat u dit lid uit deze groep verwijdert` }/></h3>
        <Textarea onChange={ event => setMotivation(event.target.value) } value={ motivation } autoFocus/>
        <div className={"text-small italic"}>
          <Trans
            text={ `Het lid zal een notificatie ontvangen met de opgegeven reden van verwijderen.` }/>
        </div>
      </div>

      <div className="dialog__buttons">
        <Button variant={ `ghost` } onClick={ () => hideDialog() }>Annuleren</Button>
        <Button variant={ `secondary` } onClick={ onConfirm }>Groepslid verwijderen</Button>
      </div>
    </>;

  if (working) {
    content = <Loader/>;
  }

  return (
    <Dialog title={ `Groepslid verwijderen` }>
      { content }
    </Dialog>
  );
}

GroupMemberRemoveDialog.propTypes = {
  groupMemberId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onCompleted: PropTypes.func.isRequired
}

export default GroupMemberRemoveDialog;
